"use client";

import { useFooterTranslations } from "@/providers/I18n/hooks/useFooterTranslations";
import { Divider } from "@itzme1on/uikit";
import Link from "next/link";
import FluxVPNLogo from "../Icons/Logos/FluxVPNLogo";
import PageContent from "../PageContent/PageContent";
import ThemeToggle from "../Theme/ThemeToggle";

export default function Footer() {
	const t = useFooterTranslations();

	const currentYear = new Date().getFullYear();

	const links = [
		{
			href: "/legal/public-offer",
			label: t("public_offer"),
		},
		{
			href: "/legal/privacy-policy",
			label: t("privacy_policy"),
		},
		{
			href: "/legal/refund-policy",
			label: t("refund_policy"),
		},
	];

	return (
		<footer>
			<PageContent className="pt-14 pb-10 px-5">
				<div className="flex flex-col gap-12">
					<div className="flex flex-col md:flex-row items-start justify-between gap-8">
						<div className="flex flex-col items-start gap-4">
							<Link
								href="/"
								className="flex flex-row items-center gap-2.5 hover:text-front select-none group/logo transition-colors"
							>
								<FluxVPNLogo
									size={32}
									className="text-primary transition-colors group-hover/logo:text-primary-accent-hover"
								/>

								<h1 className="text-xl font-bold transition-colors group-hover/logo:text-primary-accent-hover">
									FluxVPN
								</h1>
							</Link>

							<span className="text-sm text-front-secondary">
								Ваш надёжный проводник в мир безопасного интернета
							</span>
						</div>

						<div className="grid grid-cols-1 md:grid-cols-2 gap-8">
							<div className="flex flex-col gap-3">
								<h1 className="font-inter! uppercase text-xs leading-4 font-semibold tracking-[0.7px] text-front-secondary">
									Поддержка
								</h1>

								<div className="flex flex-col gap-2 text-sm [&_a:hover]:text-primary-accent-hover [&_a]:transition-colors">
									<Link href="/">Написать в Telegram</Link>

									<Link href="/">Частые вопросы</Link>
								</div>
							</div>

							<div className="flex flex-col gap-3">
								<h1 className="font-inter! uppercase text-xs leading-4 font-semibold tracking-[0.7px] text-front-secondary">
									Документы
								</h1>

								<div className="flex flex-col gap-2 text-sm [&_a:hover]:text-primary-accent-hover [&_a]:transition-colors">
									{links.map((link, index) => (
										<Link key={index} href={link.href}>
											{link.label}
										</Link>
									))}
								</div>
							</div>
						</div>
					</div>

					<Divider />

					<div className="text-sm text-front-secondary">
						© {currentYear} FluxVPN
					</div>

					<ThemeToggle />
				</div>
			</PageContent>
		</footer>
	);
}
